import { createUseStyles } from 'react-jss';
import { PricingAppTheme } from '~app/styles/theme';
import { MD_MEDIA_QUERY } from '~shared/media-query';

export default createUseStyles(({ spacing, type, palette }: PricingAppTheme) => ({
  Header: {
    textAlign: 'center',
    padding: [spacing[4], spacing[5], 0],
    '& h2': {
      fontSize: 21,
      fontWeight: type.fontWeight.medium,
    },
    '& h3': {
      fontSize: 34,
      fontWeight: type.fontWeight.medium,
      whiteSpace: 'nowrap',
      '& span': {
        fontSize: 20,
        fontWeight: 400,
      },
    },
    '& h4': {
      fontSize: 11,
    },
    '& p': {
      color: palette.text.darkMuted,
      fontSize: 16,
      marginTop: 20,
      lineHeight: 1.2,
    },
    [MD_MEDIA_QUERY]: {
      minHeight: 180,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
    },
  },
}));
